﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailClearoSuche extends GuiDetailGeneric {
    constructor() {
        super("GuiDetailClearoSuche");
    }
}
